const hasCourseRunStarted = (courseStartDate: Date) => {
  const today = new Date();
  const startDate = new Date(courseStartDate);

  return startDate && today >= startDate;
};

export default hasCourseRunStarted;
